import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { PermissionEnum } from '@ui/src';
import AdministrationRoutes from '@administration/routes';
import { useAppSelector } from '@store';
import permissionsTree from './permissions-tree';

const sections = [
  'SECTION_DASHBOARD',
  'SECTION_ACCOUNTS',
  'SECTION_CUSTOMERS',
  'SECTION_AML_KYC',
  'SECTION_TRANSACTIONS',
  'SECTION_CARDS',
  'SECTION_REPORTS',
  'SECTION_PSP',
  'SECTION_EXCHANGE_SETTINGS',
  'SECTION_FEE_TARIFFS',
  'SECTION_ADMINISTRATION',
];

const useIsAuthenticated = ({
  permissions,
}: {
  permissions?: PermissionEnum[];
}) => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      isAuthenticated &&
      (location.pathname.includes('/login') || location.pathname === '/') &&
      permissions
    ) {
      let callbackUrl = '';
      const activeSections = permissions.filter((item) =>
        item.includes('SECTION'),
      );

      const filteredSections: string[] | PermissionEnum[] = sections.filter(
        (item) => activeSections.includes(item as PermissionEnum),
      );

      const currentPermissions = permissionsTree.find(
        (item) => item.key === filteredSections[0],
      );

      if (currentPermissions) {
        if (currentPermissions.pages && currentPermissions.pages.length) {
          const { pages } = currentPermissions;

          const keys = pages?.map((item) => item.key);

          const activePages = permissions.filter((item) => keys.includes(item));

          if (activePages) {
            // @ts-ignore
            const activePage = pages.find(
              // @ts-ignore
              (item) => item.key === activePages[0],
            );

            if (activePage) {
              callbackUrl = activePage?.url;
            }
          }
        } else {
          callbackUrl = currentPermissions.url as string;
        }

        navigate(callbackUrl);
      } else {
        navigate(AdministrationRoutes.SETTINGS_PROFILE);
      }
    }
  }, [isAuthenticated, permissions]);
};

export default useIsAuthenticated;
